import {getCurrentInstance} from 'vue';
export const useChart = () => {
  /**
   * Lấy ra thông tin loại chart để render component tương ứng
   * @param {*} type Loại chart khai báo trong tập tin enum
   * @return {String}
   */
  const getChartType = type => {
    const {proxy} = getCurrentInstance();
    switch (type) {
      case 'proxy.$ms.constant.ChartType.Column':
        return 'MsColumnChart';
      case proxy.$ms.constant.ChartType.Donut:
        return 'MsDonutChart';
      default:
        return 'MsColumnChart';
    }
  };

  return {getChartType};
};
